import RnFormError from './RnFormError';

export default class FormValidationError extends RnFormError {
    constructor(message = 'Form invalid') {
        super(message);
    }
}
